<div class="all-content">
    <div class="top">
        <div class="toggle"></div>
        <i class="fas fa-xmark" (click)="exitModal()"></i>
    </div>
    <div class="row">
        <div class="circle">
            <i class="fas fa-exclamation"></i>
        </div>
    </div>
    <div class="row">
        <span class="title">
            {{ getLanguages('workflow' + '/choose_reference/confirm') }}
        </span>
    </div>
    <div class="row">
        <span class="subtitle">
            {{ getLanguages('personas/choose_reference/subtitle') }}
        </span>
    </div>

    <div class="row-100" [ngStyle]="{'flex-direction': !referenceTreeShared ? 'row' : 'row-reverse'}">
        <div class="row-50">
            <span>
                {{ corporationName }}
            </span>
        </div>
        <i class="fas fa-arrow-right"></i>
        <div class="row-50">
            <span>
                {{ getLanguages('personas/choose_reference/environment') }}
            </span>
        </div>
    </div>


    <div class="row buttons">
        <button class="confirm" (click)="saveAndClose()">
            {{ getLanguages('delete/confirm') }}
        </button>
        <button class="cancel" (click)="exitModal()">
            {{ getLanguages('delete/cancel') }}
        </button>
    </div>
</div>
